module.exports = __webpack_public_path__ + "img/welcome-to-ditto-5.2a2278c2.png";